import { Link } from 'react-router-dom';
import type { Order } from '@shared/types';

interface Props {
  orders: Order[];
}

export default function AttentionAlert({ orders }: Props) {
  const oneDayAgo = Date.now() - 24 * 60 * 60 * 1000;
  const attentionOrders = orders.filter(
    (o) =>
      (o.status === 'on_hold' || o.status === 'failed') &&
      new Date(o.created_at).getTime() > oneDayAgo,
  );

  if (attentionOrders.length === 0) return null;

  const failedCount = attentionOrders.filter((o) => o.status === 'failed').length;
  const holdCount = attentionOrders.filter((o) => o.status === 'on_hold').length;

  const parts: string[] = [];
  if (holdCount > 0) parts.push(`${holdCount} on hold`);
  if (failedCount > 0) parts.push(`${failedCount} failed`);

  return (
    <div className="border border-amber-500/20 bg-amber-500/5 rounded px-4 py-3 mb-6 flex items-center justify-between">
      <div className="flex items-center gap-2.5">
        <span className="text-amber-400 font-mono text-sm">△</span>
        <p className="font-sans text-sm text-amber-300/90">
          {attentionOrders.length} order{attentionOrders.length > 1 ? 's' : ''} need attention
          <span className="text-zinc-500 ml-2 text-xs">({parts.join(', ')})</span>
        </p>
      </div>
      <Link
        to="/dashboard/crypto/orders"
        className="font-mono text-xs text-amber-400 hover:text-amber-300 transition-colors"
      >
        View orders
      </Link>
    </div>
  );
}
